import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-conditions',
  templateUrl: './conditions.component.html',
  styleUrls: ['./conditions.component.css'],
})
export class ConditionsComponent implements OnInit {
  @Output() onClose = new EventEmitter<any>();

  condiciones = false;

  constructor() {}

  ngOnInit(): void {}

  continuar() {
    this.onClose.emit(this.condiciones);
  }
}
